import axiosInstance from "../../../config/axios-config";

export const GetTenantData = async ({tenantId}) => {
    try {
        const response = await axiosInstance.get(`/api/v1/tenants/${tenantId}`);
        console.log(response.data);
        return response.data;
    } catch (err) {
        console.error("Error fetching tenant data:", err);
    }
};